import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';
import SaveButton from './ui/SaveButton';
import { useSettingsContext } from '../../contexts/settings';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const linkText = post.post_type === 'resource' ? `View Resource` : `Read More`;
	const target = post.external_url ? `_blank` : `_self`;
	const rel = post.external_url ? `noreferrer noopener` : `noreferrer`;

	const settings = useSettingsContext();

	return (
		<div className={`pfa-card-wrapper pfa-card-wrapper--${post.post_type}`}>
			<a href={post.permalink} target={target} rel={rel} className="pfa-card-default">
				{!!post.featured_image && (
					<figure
						className="pfa-card-default__img-wrapper"
						dangerouslySetInnerHTML={{ __html: post.featured_image }}
					/>
				)}
				<div className="pfa-card-default__text">
					{post.content_type.name && (
						<div className="pfa-card-default__tag-container">
							<span className={`icon-${post.content_type_icon}`}></span>
							<p
								className="pfa-card-default__tag post-tag"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.content_type.name),
								}}
							/>
						</div>
					)}
					<div className="pfa-card-default__content">
						{post.post_title && (
							<h3
								className="pfa-card-default__title"
								dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
							/>
						)}
						{post.post_excerpt && (
							<p
								className="pfa-card-default__excerpt"
								dangerouslySetInnerHTML={{
									__html: sanitizeHtml(post.post_excerpt),
								}}
							/>
						)}
					</div>
					<span className="pfa-card-default__link btn-tertiary">{linkText}</span>
				</div>
			</a>
			{settings.isLoggedIn && (
				<SaveButton id={post.ID} isSaved={post.is_saved} title={post.post_title} />
			)}
		</div>
	);
};

Default.displayName = 'Default';

export default Default;
